import styled from 'styled-components'

export default styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  font-size: 1.4rem;

  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1270px) {
    max-width: 1240px;
  }

  .content {
    .description {
      text-align: center;
      font-size: 1.8rem;
      font-weight: bold;
    }

    .description_price {
      text-align: center;
      font-size: 2.4rem;
      font-weight: bold;
      margin-top: 0.5rem;
    }

    .card-element {
      width: 100%;
      max-width: 50rem;
    }

    .error-msg {
      color: ${(props) => props.theme.palette.error};
    }
  }

  .stripe {
    width: 12rem;
  }
`
